import { html } from '@design.estate/dees-element';
import { demoPage } from '../../../demos/templates.js';
import type { ITerminalResizeDetail } from './dees-terminal-view.js';

// A serialized terminal state as a host would receive it on reattach, e.g. from xterm's
// serialize addon: styled rows at the grid the PTY had when it was taken.
const sampleSnapshotSize: ITerminalResizeDetail = { cols: 64, rows: 12 };
const samplePrompt = '\x1b[1;32m➜\x1b[0m \x1b[36mdees-catalog\x1b[0m ';
const sampleSnapshot = [
  `${samplePrompt}pnpm build`,
  '\x1b[2mtsbuild \x1b[0m compiled the web folder',
  '\x1b[2mtsbundle\x1b[0m wrote dist_bundle/bundle.js',
  '',
  `${samplePrompt}pnpm test`,
  ' \x1b[32m✔\x1b[0m restore() sizes, parses, fits and reveals',
  ' \x1b[32m✔\x1b[0m writes during a restore follow the snapshot',
  ' \x1b[32m✔\x1b[0m a newer restore supersedes an older one',
  '',
  samplePrompt,
].join('\r\n');

const restoreSample = (event: Event): void => {
  const view = (event.currentTarget as HTMLElement)
    .closest('.terminalDemoStack')
    ?.querySelector('dees-terminal-view');
  if (!view) return;
  // A click handler's promise is dropped by the DOM, so both outcomes are settled here: leaving
  // the demo page mid-restore rejects, and nobody would be left to observe it.
  view.restore(sampleSnapshot, sampleSnapshotSize).then(
    () => view.focus(),
    () => undefined,
  );
};

// A loopback demo: keystrokes echo straight back into the terminal so the
// component is explorable without a live PTY behind it.
export const demoFunc = () => demoPage('Terminal', 'A terminal surface with local keyboard echo. Type to try the input and resize behavior, or restore a serialized snapshot: it is painted invisibly at its own grid and appears fitted, in one step.', html`
  <style>
    .terminalDemo {
      height: 380px;
      border: 1px solid var(--dees-color-border-default);
      border-radius: var(--dees-radius-xl);
      overflow: hidden;
    }
  </style>
  <div class="terminalDemoStack dees-demo-stack">
    <div class="dees-demo-row">
      <dees-button @clicked=${restoreSample}>Restore a snapshot</dees-button>
    </div>
    <div class="terminalDemo">
      <dees-terminal-view
        @terminal-input=${(event: CustomEvent<{ data: string }>) => {
          const view = event.currentTarget as HTMLElementTagNameMap['dees-terminal-view'];
          const data = event.detail.data;
          view.write(data === '\r' ? '\r\n' : data);
        }}
        @terminal-resize=${(event: CustomEvent<ITerminalResizeDetail>) => {
          console.log('terminal size', event.detail);
        }}
      ></dees-terminal-view>
    </div>
  </div>
`);
